import { Suspense } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import { PaymentFakeGateway } from 'hb-react/frontoffice/components/payments';
import { usePaymentContext } from 'hb-react/shared/components/Payment/context/PaymentContext';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const FakeGateway = () => {
  const {
    amount,
    billingData,
    currency,
    onSuccess,
    paymentAccountConfig,
    paymentData,
    paymentEndpoint,
  } = usePaymentContext();

  const props = {
    amount,
    currency,
    endpoint: paymentEndpoint,
    onSuccess,
    payment: { gateway: paymentAccountConfig.type },
    payload: {
      ...paymentData,
      billing: billingData,
    },
  };

  return (
    <Box flexDirection="column">
      <PaymentFakeGateway {...props} />
    </Box>
  );
};

const PaymentStubWrapper = (props) => (
  <Suspense fallback={null}>
    <ThemeProvider theme="fo">
      <FakeGateway {...props} />
    </ThemeProvider>
  </Suspense>
);

export default PaymentStubWrapper;
